import { render, staticRenderFns } from "./skinPackageTwe.vue?vue&type=template&id=c3b4ba42&scoped=true"
import script from "./skinPackageTwe.vue?vue&type=script&lang=js"
export * from "./skinPackageTwe.vue?vue&type=script&lang=js"
import style0 from "./skinPackageTwe.vue?vue&type=style&index=0&id=c3b4ba42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b4ba42",
  null
  
)

export default component.exports